import type { Dealer, DealerFormData } from "../DealersPage";

interface EditDealerDataSaveHandlerParams {
  dealerFormData: DealerFormData;
  isNewDealer: boolean;
  activeDealer: Dealer | undefined;
  setActiveDealer: (dealer: Dealer | undefined) => void;
  reloadData: () => void;
  user: { getIdToken: () => Promise<string> } | null;
}

export const editDealerDataSaveHandler = async ({
  dealerFormData,
  isNewDealer,
  activeDealer,
  setActiveDealer,
  reloadData,
  user,
}: EditDealerDataSaveHandlerParams): Promise<void> => {
  const verification = confirm(
    isNewDealer
      ? `Create new dealer: ${dealerFormData.name} ?`
      : `Save changes for ${activeDealer?.name} ?`,
  );

  if (!verification) {
    alert("No changes saved");
    return;
  }

  if (!user) {
    alert("User is not authenticated");
    return;
  }

  try {
    const path = `/v1/dealer${isNewDealer ? "" : `/${activeDealer?.id ?? ""}`}`;
    const url = new URL(path, __API_BASE_URL__).toString();
    const body = { ...dealerFormData };
    const res = await fetch(url, {
      method: isNewDealer ? "POST" : "PUT",
      headers: {
        "content-type": "application/json",
        "x-jwt": await user.getIdToken(),
      },
      body: JSON.stringify(body),
    });
    const data: unknown = await res.json();
    if (!res.ok) {
      throw new Error(JSON.stringify(data));
    }
    alert("Success!");
    setActiveDealer(undefined);
    reloadData();
  } catch (error) {
    const messagePrefix = `Error ${isNewDealer ? "Creating new" : "Updating"} dealer`;
    console.log(messagePrefix, error);
    alert(messagePrefix);
  }
};
